import CustomFormGroup from "../../../../components/form/CustomFormGroup";

const BankForm = ({ handleChange, updateAccountForm }) => {
  return (
    <>
      <CustomFormGroup
        label="ເລກບັນຊີ"
        name="accountNo"
        onChange={handleChange}
        type="text"
        value={updateAccountForm.accountNo}
        placeholder="ເລກບັນຊີ"
        errorParam="accountNo"
        required={true}
      />
      <CustomFormGroup
        label="ຊື່ບັນຊີ"
        name="accountName"
        onChange={handleChange}
        type="text"
        value={updateAccountForm.accountName}
        placeholder="ຊື່ບັນຊີ"
        errorParam="accountName"
        required={true}
      />
      <CustomFormGroup
        label="ຊື່ທະນາຄານ"
        name="bankName"
        onChange={handleChange}
        type="text"
        value={updateAccountForm.bankName}
        placeholder="ຊື່ທະນາຄານ"
        errorParam="bankName"
        required={true}
      />
    </>
  );
};

export default BankForm;
